import { rei } from "@/services/api"

class AtualizarRegistros {
  static descerRegistrosCrc (data) {
    return rei.post(`registros-crc`, data).then(res => res.data)
  }
}

export default AtualizarRegistros
